import React, { Suspense, lazy } from 'react';
import pt from 'prop-types';
import Flash from 'components/flash';
import LoadingBar from 'components/loading/bar';
import getModal from 'partners/containers/modals';
import { NavMain } from 'partners/components/nav';
import { isV2Enabled } from 'utils/dashboard-version';
import { NewExperienceBoundary } from 'components/dashboard-switch';

import 'components/layout/main.scss';

// Loaded on demand, so v2 stays out of the bundle the merchant dashboard
// shares with this portal and its styles load after the classic global ones.
const PartnersV2Root = lazy(() => import('partners/v2'));

export default class MainLayout extends React.Component {
  static propTypes = {
    router: pt.object,
    flash: pt.object,
    nav: pt.object,
    modal: pt.object,
    children: pt.node,
  };

  static contextTypes = {
    onClickLogout: pt.func,
    onClickSwitchPartner: pt.func,
  };

  renderActiveModals(modal, props) {
    return modal.stack.map((activeModal, index) =>
      typeof activeModal.props === 'function' ? (
        <activeModal.props key={index} {...props} />
      ) : (
        getModal(activeModal.id, index, { ...props, ...activeModal.props })
      ),
    );
  }

  render() {
    const { nav, flash, children, modal, ...props } = this.props;

    const { routes } = this.props.router;
    const targetRoute = routes[routes.length - 1];
    const showingLayout = targetRoute.layout !== false;
    const showingLoader = targetRoute.loader !== false;

    // The new experience (v2), when this browser has switched to it
    // (utils/dashboard-version). Pages v2 hasn't rebuilt render inside its
    // shell; classic modals stay on top of it.
    if (showingLayout && isV2Enabled()) {
      return (
        <>
          <NewExperienceBoundary>
            <Suspense fallback={null}>
              <PartnersV2Root
                {...props}
                flash={flash}
                onClickLogout={this.context.onClickLogout}
                onClickSwitchPartner={this.context.onClickSwitchPartner}
              >
                {children}
              </PartnersV2Root>
            </Suspense>
          </NewExperienceBoundary>
          {showingLoader && <LoadingBar />}
          {this.renderActiveModals(modal, props)}
        </>
      );
    }

    return (
      <div id="main" className="layout-container">
        <Flash {...flash} />
        {showingLoader && <LoadingBar />}
        {showingLayout ? (
          <div>
            <NavMain nav={nav} {...props} />
            <div className="layout-content partner-dashboard">{children}</div>
          </div>
        ) : (
          children
        )}
        {this.renderActiveModals(modal, props)}
      </div>
    );
  }
}
